import { useTranslation } from "react-i18next";
import { useState } from "react";
import styles from "./DeleteSurveyModal.module.css";

export default function DeleteSurveyModal({ surveyID, onConfirm, onCancel, isLoading }) {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState("");
    const [error, setError] = useState("");

    function handleConfirm() {
        if (inputValue.trim() === "") {
            setError(t("deleteSurvey.modal.idRequired", { defaultValue: "ID ankiety jest wymagane" }));
            return;
        }

        if (inputValue.trim() !== surveyID) {
            setError(t("deleteSurvey.modal.idMismatch", { defaultValue: "ID ankiety jest nieprawidłowe" }));
            return;
        }

        onConfirm(inputValue.trim());
    }

    return (
        <div className={styles.overlay} onClick={onCancel}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h2>{t("deleteSurvey.modal.title", { defaultValue: "Usuń ankietę" })}</h2>
                    <button
                        className={styles.closeButton}
                        onClick={onCancel}
                        disabled={isLoading}
                        aria-label="Close"
                    >
                        ✕
                    </button>
                </div>

                <div className={styles.content}>
                    <div className={styles.warning}>
                        <span className={styles.warningIcon}>⚠️</span>
                        <p>
                            {t("deleteSurvey.modal.warning", {
                                defaultValue:
                                    "Usunięcie bazy danych jest nieodwracalne! Ankieta i wszystkie odpowiedzi dla tej ankiety będą trwale usunięte z bazy danych.",
                            })}
                        </p>
                    </div>

                    <div className={styles.formGroup}>
                        <label htmlFor="surveyIdInput">
                            {t("deleteSurvey.modal.idLabel", {
                                defaultValue: "Wpisz ID ankiety aby potwierdzić:",
                            })}
                        </label>
                        <input
                            id="surveyIdInput"
                            type="text"
                            value={inputValue}
                            onChange={(e) => {
                                setInputValue(e.target.value);
                                setError("");
                            }}
                            placeholder={surveyID}
                            disabled={isLoading}
                            className={styles.input}
                            autoFocus
                        />
                        {error && <div className={styles.error}>{error}</div>}
                        <small className={styles.hint}>
                            <code>{surveyID}</code>
                        </small>
                    </div>
                </div>

                <div className={styles.footer}>
                    <button
                        className={styles.cancelButton}
                        onClick={onCancel}
                        disabled={isLoading}
                    >
                        {t("common.cancel", { defaultValue: "Anuluj" })}
                    </button>
                    <button
                        className={styles.confirmButton}
                        onClick={handleConfirm}
                        disabled={isLoading || !inputValue}
                    >
                        {isLoading
                            ? t("deleteSurvey.modal.deleting", { defaultValue: "Usuwanie..." })
                            : t("deleteSurvey.modal.confirm", { defaultValue: "Usuń ankietę" })}
                    </button>
                </div>
            </div>
        </div>
    );
}
